var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFoodAndDrink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Restaurant-Eating-Set--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Restaurant Eating Set Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 0a0.76 0.76 0 0 0 -0.75 0.75V23a1 1 0 0 0 2 0v-8a0.5 0.5 0 0 1 0.5 -0.5h1.75A1.25 1.25 0 0 0 24 13.25C23.94 6.06 21.58 0 19.25 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 10a5.75 5.75 0 1 0 5.75 5.75A5.76 5.76 0 0 0 11.75 10Zm0 9.5a3.75 3.75 0 1 1 3.75 -3.75 3.75 3.75 0 0 1 -3.75 3.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0a1 1 0 0 0 -1 1v5a2 2 0 0 1 -0.57 1.4 0.25 0.25 0 0 1 -0.27 0A0.24 0.24 0 0 1 5 7.22V1a1 1 0 0 0 -2 0v6.22a0.24 0.24 0 0 1 -0.16 0.23 0.25 0.25 0 0 1 -0.27 0A2 2 0 0 1 2 6V1a1 1 0 0 0 -2 0v5a4 4 0 0 0 2.67 3.77 0.5 0.5 0 0 1 0.33 0.47V23a1 1 0 0 0 2 0V10.24a0.5 0.5 0 0 1 0.33 -0.47A4 4 0 0 0 8 6V1a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFoodAndDrink);
export default ForwardRef;